import { createAction, DateTimeUtcService } from '@mews/framework';
import { TaskState } from '@mews-commander/data-access';
import { RouteName } from '@mews-commander/enums';
import { CommanderThunkAction } from '@mews-commander/types';
import { createPollerActions } from '@mews-commander/utils';
import { fetchCurrentEnterpriseTasks } from '@mews-commander/legacy-entities/src/actions/tasks';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { getEndOfTodayUtc } from '@mews-commander/legacy-entities/src/selectors/session/dateTime';
import { navigateInModal } from '../../app/actions/common';
import { isLoaded, getLastModified, getPreviousMonthUtc } from '../selectors/tasks';
import { prefix } from '../module';
import { getTaskReportIndexQueryParams, shouldFetch } from './util';

const TASKS_STATISTICS_INTERVAL = 5 * 60 * 1000;

export const TASK_STATISTICS_FETCH_SUCCEEDED = prefix('TASK_STATISTICS_FETCH_SUCCEEDED');

const shouldFetchTasks = shouldFetch(isLoaded, getLastModified, TASKS_STATISTICS_INTERVAL);

const fetchTodayTasks =
    (): CommanderThunkAction =>
    (dispatch, getState, { appClockService }) => {
        const state = getState();
        if (shouldFetchTasks(state, appClockService.getValue())) {
            const endDateTimeUtc = getEndOfTodayUtc(state, { appClockService });
            const previousMonth = getPreviousMonthUtc(state, { appClockService });

            const params = {
                state: TaskState.Open,
                deadlineUtc: {
                    startUtc: previousMonth,
                    endUtc: endDateTimeUtc,
                },
            };
            dispatch(fetchCurrentEnterpriseTasks(params)).then(() => {
                const lastModified = appClockService.getValue();
                return dispatch(createAction(TASK_STATISTICS_FETCH_SUCCEEDED, { lastModified }));
            });
        }
    };

export const [startTasksStatisticsPoller, stopTasksStatisticsPoller] = createPollerActions(
    fetchTodayTasks,
    TASKS_STATISTICS_INTERVAL
);

export const navigateToTaskReport =
    (): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute, appClockService }) => {
        const state = getState();
        const timezone = getCurrentEnterpriseIanaTimeZoneIdentifier(state);
        const nowUtc = DateTimeUtcService.toISOString(appClockService.getAppNowUtc());
        const startUtc = getPreviousMonthUtc(state, { appClockService });
        const url = resolveRoute(RouteName.TaskReportIndex, {
            query: getTaskReportIndexQueryParams(timezone, nowUtc, startUtc),
        });
        dispatch(navigateInModal(url));
    };
